module.exports = __webpack_public_path__ + "img/48-l.852ada2b.png";